// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Statistics_wrapper .text {\n  font-size: 14px;\n}\n.Statistics_wrapper .item {\n  padding: 18px 0;\n}\n.Statistics_wrapper .box-card {\n  width: 480px;\n}\n.Statistics_wrapper .box-card .el-card__body {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
